__turbopack_context__.v({
  "wrapper": "flags-module-scss-module__-Lhxcq__wrapper",
});
